import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeHelpArticleSkeleton } from './TypeHelpArticle'

export interface TypeHelpSubcategoryFields {
  title: EntryFieldTypes.Symbol
  items: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeHelpArticleSkeleton>>
}

export type TypeHelpSubcategorySkeleton = EntrySkeletonType<TypeHelpSubcategoryFields, 'helpSubcategory'>
export type TypeHelpSubcategory<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeHelpSubcategorySkeleton,
  Modifiers,
  Locales
>

export function isTypeHelpSubcategory<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeHelpSubcategory<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'helpSubcategory'
}
